(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["book-row"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bayeux-carousel')) {
    class BayeuxCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.prev = this.querySelector('[data-carousel-prev]');
        this.next = this.querySelector('[data-carousel-next]');
        if (!this.track) return;
        this.prev?.addEventListener('click', () => this.page(-1));
        this.next?.addEventListener('click', () => this.page(1));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        new ResizeObserver(() => this.update()).observe(this.track);
        this.update();
      }

      page(direction) {
        const item = this.track.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
        const perPage = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));
        this.track.scrollBy({ left: direction * step * perPage, behavior: 'smooth' });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth - 1;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 0;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max;
        this.classList.toggle('is-static', max <= 0);
      }
    }
    customElements.define('bayeux-carousel', BayeuxCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-nav"] && !Shopify.designMode) return;
  try {
    (() => {
    const closeMenu = (details, returnFocus) => {
      details.removeAttribute('open');
      const summary = details.querySelector('summary');
      summary?.setAttribute('aria-expanded', 'false');
      if (returnFocus) summary?.focus();
    };

    document.addEventListener('keyup', (event) => {
      if (event.code !== 'Escape') return;
      const open = document.querySelector('.header-nav details[open]');
      if (open) closeMenu(open, open.contains(document.activeElement));
    });

    document.addEventListener('click', (event) => {
      document.querySelectorAll('.header-nav details[open]').forEach((details) => {
        if (!details.contains(event.target)) closeMenu(details, false);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('search-overlay')) {
    class SearchOverlay extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-search-dialog]');
        this.input = this.querySelector('[data-search-input]');
        this.popular = this.querySelector('[data-search-popular]');
        this.live = this.querySelector('[data-search-live]');
        this.strings = {
          products: this.dataset.labelProducts || 'Books',
          films: this.dataset.labelFilms || 'Films',
          none: this.dataset.labelNone || 'No books match',
          all: this.dataset.labelAll || 'See all results →',
        };

        this.querySelector('[data-search-open]').addEventListener('click', () => this.open());
        this.querySelector('[data-search-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });

        let timer;
        this.input.addEventListener('input', () => {
          clearTimeout(timer);
          timer = setTimeout(() => this.search(this.input.value.trim()), 250);
        });
      }

      open() {
        this.dialog.showModal();
        this.input.focus();
        this.input.select();
      }

      tidyName(value) {
        return (value || '')
          .split(' ')
          .map((word) => (word.length > 2 && word === word.toUpperCase() ? word.charAt(0) + word.slice(1).toLowerCase() : word))
          .join(' ');
      }

      escape(value) {
        const span = document.createElement('span');
        span.textContent = value || '';
        return span.innerHTML;
      }

      async search(query) {
        if (!query) {
          this.live.hidden = true;
          if (this.popular) this.popular.hidden = false;
          return;
        }
        this.controller?.abort();
        this.controller = new AbortController();
        try {
          const url = `${window.routes.predictive_search_url}.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`;
          const response = await fetch(url, { signal: this.controller.signal });
          const data = await response.json();
          const products = data?.resources?.results?.products || [];
          const searchUrl = `${this.querySelector('form').getAttribute('action')}?q=${encodeURIComponent(query)}&options[prefix]=last`;
          // Films (watch products tagged video-access) are listed apart from books; their
          // product URL forwards to the film page.
          const isFilm = (product) => (product.tags || []).includes('video-access');
          const films = products.filter(isFilm);
          const books = products.filter((product) => !isFilm(product));
          const rowsOf = (list) => list
            .map((product) => {
              const image = product.featured_image?.url || product.image;
              const thumb = image ? `<img src="${image}${image.includes('?') ? '&' : '?'}width=72" alt="" loading="lazy">` : '';
              const vendor = product.vendor && !/bayeux/i.test(product.vendor) ? `<span class="search-overlay__meta">${this.escape(this.tidyName(product.vendor))}</span>` : '';
              return `<li><a class="search-overlay__row" href="${product.url}"><span class="search-overlay__thumb">${thumb}</span><span class="search-overlay__text"><span class="search-overlay__name">${this.escape(product.title)}</span>${vendor}</span></a></li>`;
            })
            .join('');
          const group = (label, list) => (list.length ? `<p class="search-overlay__label">${label}</p><ul class="search-overlay__list" role="list">${rowsOf(list)}</ul>` : '');
          this.live.innerHTML = products.length
            ? `${group(this.strings.films, films)}${group(this.strings.products, books)}<a class="link-explore link-explore--small search-overlay__all" href="${searchUrl}">${this.strings.all}</a>`
            : `<p class="search-overlay__empty">${this.strings.none} “${this.escape(query)}”.</p><a class="link-explore link-explore--small search-overlay__all" href="${searchUrl}">${this.strings.all}</a>`;
          this.live.hidden = false;
          if (this.popular) this.popular.hidden = true;
        } catch (error) {
          if (error.name !== 'AbortError') this.live.hidden = true;
        }
      }
    }
    customElements.define('search-overlay', SearchOverlay);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["listing-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('listing-filters')) {
    class ListingFilters extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('[data-listing-form]');
        this.sortInput = this.querySelector('[data-listing-sort-input]');
        if (!this.dialog || !this.form) return;

        this.form.addEventListener('change', (event) => {
          if (event.target.matches('[data-listing-sort]')) this.sortInput.value = event.target.value;
          this.submit();
        });
        this.querySelectorAll('[data-filter-show-all]').forEach((button) =>
          button.addEventListener('click', () => {
            const list = document.getElementById(button.getAttribute('aria-controls'));
            list?.querySelectorAll('[data-filter-more]').forEach((item) => item.removeAttribute('hidden'));
            button.setAttribute('aria-expanded', 'true');
            button.hidden = true;
            list?.querySelector('[data-filter-more] input')?.focus();
          })
        );
        this.querySelectorAll('[data-listing-close]').forEach((button) =>
          button.addEventListener('click', () => this.dialog.open && this.dialog.close())
        );
        document.querySelectorAll('[data-listing-open]').forEach((button) =>
          button.addEventListener('click', () => this.dialog.showModal())
        );
        document.querySelectorAll('[data-listing-sort-external]').forEach((select) =>
          select.addEventListener('change', () => {
            this.sortInput.value = select.value;
            this.submit();
          })
        );
      }

      submit() {
        const params = new URLSearchParams(new FormData(this.form));
        [...params.keys()].forEach((key) => {
          if (params.get(key) === '') params.delete(key);
        });
        const query = params.toString();
        const url = this.form.action + (query ? `?${query}` : '');
        const listing = this.closest('ajax-listing');
        if (listing && typeof listing.load === 'function') listing.load(url);
        else window.location.href = url;
      }
    }
    customElements.define('listing-filters', ListingFilters);
  }
  } catch(e) { console.error(e); }
})();

})();
